<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 41"
        :class="customClasses"
    >
        <path fill="#4E869E" fill-rule="evenodd" d="M15 8a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm0-7.5C6.73.5 0 7.23 0 15.5c0 4.678 2.26 10.214 6.716 16.453 3.207 4.492 6.382 7.681 6.517 7.814.487.49 1.128.733 1.767.733.64 0 1.28-.244 1.767-.733.135-.133 3.31-3.322 6.517-7.814C27.741 25.714 30 20.178 30 15.5c0-8.27-6.73-15-15-15z"/>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
            })

            return {
                customClasses
            }
        }
    })
</script>